import { useEffect, useState } from "react";
import SidePanel from "../../components/SidePanel";
import rightIcon from "../../assets/pic/righticon.svg";
import Spinner from "../../components/Spinner";
import ConfirmationModal from "../../components/ConfirmationModal";
import moment from "moment/moment";
import { LayoutForLandingPage } from "./Home";
import { useNavigate } from "react-router-dom";
import offer from "../../assets/pic/offer/offer.svg";
const PlanCard = ({
  quantity,
  price,
  features,
  is_subscribed,
  stripeCustomerId,
  stripPlansinfo,
  basicSubscriptionPlanId,
  planId,
  me = {},
  subscription,
  index,
}) => {
  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  console.log("quantity: ", quantity);
  const navigate = useNavigate();

  const toggleModal = () => {
    setIsModalVisible((prev) => !prev);
  };

  const handleConfirmUpgrade = () => {
    upgradePlan();
    toggleModal(); // Close the modal
  };
  const handleSubcribe = async () => {
    if (is_subscribed) {
      // Early return if the user is already subscribed
      return;
    }
    setLoader(true);
    const token = localStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/customer/stripeCheckout`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
        body: JSON.stringify({
          stripeProductId: planId,
        }),
      }
    );
    const data = await res.json();
    setLoader(false);
    if (data.code === 200) {
      window.location.href = data.subscription;
    }
  };

  const handleManageSubscription = async () => {
    if (!stripeCustomerId) {
      console.error("Stripe customer ID is missing");
      return;
    }
    setLoader(true);
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/stripePlan/create-portal-session?stripeCustomerId=` +
          stripeCustomerId,
        {
          method: "POST", // Adjust based on your backend requirements
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        // Handle error or invalid response
        console.error("Failed to obtain portal session URL:", data.message);
      }
    } catch (error) {
      console.error("Error managing subscription:", error);
    } finally {
      setLoader(false);
    }
  };

  const upgradePlan = async () => {
    if (!stripeCustomerId) {
      console.error("Stripe customer ID is missing");
      return;
    }
    setLoader(true);
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/stripePlan/upgrade_Plane/${planId}/${basicSubscriptionPlanId}`,
        {
          method: "POST", // Adjust based on your backend requirements
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      console.log({ data });
      window.location.href = "/dashboard/premium_plan";
      // if (data.url) {
      //   window.location.href = data.url;
      // } else {
      //   // Handle error or invalid response
      //   console.error("Failed to obtain portal session URL:", data.message);
      // }
    } catch (error) {
      console.error("Error managing subscription:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-full ">
      {isModalVisible && (
        <ConfirmationModal
          title="Upgrade Plan"
          message={`You are upgrading to the $12.95. This plan will activate once your current plan expires.`}
          confirmText="Upgrade"
          cancelText="Cancel"
          onConfirm={handleConfirmUpgrade}
          onCancel={toggleModal}
          toggleModal={toggleModal}
        />
      )}
      {/* <h1 className="mt-8 font-semibold text-[#2F3649] text-[48px]">Pricing</h1> */}
      <div className="flex flex-col justify-center items-center w-full h-full">
        {/* {features.map((plan, index) => ( */}
        <div
          className={`flex lg:flex-row flex-col pb-12 gap-2 mt-6 w-full h-full justify-center items-center ${
            quantity === "4" && "md:justify-start"
          } ${quantity === "Free Plan" && "md:justify-end"}`}
        >
          <div className="w-80 min-h-[400px]  rounded-lg shadow-lg">
            <div className="w-full h-20 relative rounded-tl-lg rounded-tr-lg items-center justify-center flex bg-[#F1E3E4] text-[24px]">
              <span className="text-[32px] text-primary font-semibold">
                {/* {quantity === "Free Plan"
                  ? quantity + " "
                  : quantity + " Cards"} */}
                {quantity === "Single Card Option"
                  ? quantity + " "
                  : quantity + " Cards"}
              </span>
              <p className="text-[24px] mt-2 font-semibold text-[#2F3649]">
                {/* {quantity === "Free Plan" ? "" : "/Month"} */}
                {quantity === "Single Card Option" ? "" : "/Month"}
              </p>
              {quantity !== "Single Card Option" && (
                <img
                  className="absolute w-1/3 -top-[40px] -right-[30px] lg:-top-[110px] lg:-right-[115px] xl:-right-[185px] xl:-top-[140px] md:w-2/5 lg:w-2/3 xl:w-11/12 "
                  src={offer}
                  alt="offer-img"
                />
              )}
            </div>
            <div className="p-8 flex flex-col justify-start items-start">
              <span className="text-primary text-[32px] flex font-semibold">
                {price}
                <p className="text-[22px] font-[400px] text-[#2F3649] mt-2">
                  {quantity === "Single Card Option" ? "" : "/mo"}
                </p>
              </span>
              <ul className="flex flex-col gap-3 mt-2 font-[400px]">
                {features.map((feature, index) => (
                  <span key={index} className="flex gap-2 text-black">
                    <img src={rightIcon} alt=""></img>
                    {feature.feature}
                  </span>
                ))}
              </ul>

              {loader ? (
                <div className="flex items-center justify-center w-full mt-2">
                  <Spinner props=" " size={"80"} />
                </div>
              ) : is_subscribed ? (
                <button
                  onClick={() => {
                    const token = localStorage.getItem("token");
                    if (token) {
                      handleManageSubscription();
                    } else {
                      navigate("/login");
                    }
                  }}
                  className={`w-full border-2 font-bold mt-4 text-center py-3 bg-primary text-white rounded-md hover:bg-primary-dark duration-300 ease-linear
                   ${quantity === "Free Plan" ? "hidden" : "block"}
                  `}
                >
                  Manage My Subscription
                </button>
              ) : (
                //</> <button
                //   onClick={handleSubcribe}
                //   className="w-full border-2 font-bold text-center py-3 bg-black text-white rounded-md hover:border-2 hover:border-black hover:bg-white hover:text-primary duration-300 ease-linear"
                //   disabled={ is_subscribed}
                // >
                //   { is_subscribed ? "Subscribed" : "Subscribe"}
                // </button>
                <>
                  <button
                    onClick={() => {
                      const token = localStorage.getItem("token");

                      if (token) {
                        if (me?.amount == "12.5") {
                          toggleModal();
                        } else {
                          handleSubcribe();
                        }
                        if (quantity === "Single Card Option") {
                          navigate("/dashboard/card_generation");
                        }
                      } else {
                        navigate("/signup");
                      }
                      // if (quantity === "Single Card Option") {
                      //   navigate("/dashboard/card_generation");
                      // }
                    }}
                    className={`w-full border-2 font-bold mt-4 text-center px-10 py-3 rounded-md md:text-xl text-sm duration-300 ease-linear ${
                      me?.amount === "12.95" || is_subscribed || me.upgradedAt
                        ? "bg-gray-400 text-white border-gray-400" // Styles for subscribed (disabled) state
                        : "bg-primary text-white hover:border-2 hover:border-primary hover:bg-white hover:text-primary" // Styles for active (not subscribed) state
                    }
                    ${price === "Free" ? " mt-[110px] " : ""}
                `}
                    disabled={
                      me?.amount === "12.95" || is_subscribed || me.upgradedAt
                    }
                  >
                    {quantity === "Single Card Option"
                      ? "Free"
                      : me?.amount == "12.5"
                      ? me.upgradedAt
                        ? `Activation Date: ${moment(me.upgradedAt).format(
                            "DD-MM-YYYY"
                          )}`
                        : "Upgrade"
                      : "Subscribe"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        {/* ))} */}
      </div>
    </div>
  );
};

const PremiumPlan = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [stripeCustomerId, setstripeCustomerId] = useState(false);
  const [loader, setLoader] = useState(false);
  const [stripPlansinfo, setStripePlansInfo] = useState([]);
  const [subscription, setSubscrition] = useState([]);
  const [me, setMe] = useState({});
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoader(true);
        const token = localStorage.getItem("token");
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/stripePlan/get-plans`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        setStripePlansInfo(data.plans);
      } catch (error) {
      } finally {
        setLoader(false);
      }
    };
    fetchPlans();
  }, []);
  useEffect(() => {
    const fetchUserProfile = async () => {
      setLoader(true); // Start loading
      const token = localStorage.getItem("token");
      if (!token) {
        // Handle case where the user is not logged in or the token is not available
        console.error("No token found");
        setLoader(false); // Stop loading if there's an error
        return;
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            // Adjusted to point to a profile endpoint
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await response.json();
        console.log("data: xxxx ", data);
        if (data) {
          setIsSubscribed(data.detail.isSubscribed);
          setstripeCustomerId(data.detail.stripeCustomerId);
          setSubscrition(data.detail.subscription);
          setMe(data.detail);
        }
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      } finally {
        setLoader(false);
      }
    };

    fetchUserProfile();
  }, []);

  const plans = [
    {
      index: 0,
      quantity: "Single Card Option",
      price: "$4.95 / card",
      features: [
        { index: 1, feature: "Unlimited recipients" },
        { index: 2, feature: "Access to message generator" },
        { index: 3, feature: "Full Access to Calendar" },
        {
          index: 4,
          feature: "Receive email reminders of your upcoming events",
        },
        {
          index: 5,
          feature: "Unlimited printed and mailed cards each month",
        },
      ],
      is_subscribed: isSubscribed,
    },
    {
      index: 1,
      quantity: "4",
      price: "$12.95",
      planId:
        stripPlansinfo?.filter((sub) => sub.amount === 12.95)[0]?.id || "",
      basicSubscriptionPlanId:
        subscription?.filter((sub) => sub.amount === "12.5")[0]
          ?.subscriptionID || "",
      features: [
        { index: 11, feature: "$3.25 per Card or $12.95/mo" },
        { index: 21, feature: "Cancel anytime" },
        { index: 31, feature: "Unlimited recipients" },
        { index: 41, feature: "Access to message generator" },
        {
          index: 4,
          feature: "Full Access to Calendar",
        },
        {
          index: 51,
          feature: "Receive email reminders of your upcoming events",
        },
        { index: 61, feature: "4 printed and mailed cards each month" },
      ],
      is_subscribed:
        subscription?.find((sub) => sub.amount === "12.95")?.isSubscribed ||
        false,
    },
  ];
  
  console.log({ subscription });
  if (loader) {
    return (
      <section className="flex">
        {/* <SidePanel /> */}
        <div className="w-full  lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div className="h-screen flex items-center justify-center">
            <Spinner props="Loading" size={"80"} />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="flex">
      {/* <SidePanel /> */}
      <div className="my-10 w-full flex flex-col justify-center">
        <h1 className="text-4xl text-secondary font-bold text-center mb-2 mt-16">
          Our Plans
        </h1>
        <LayoutForLandingPage>
          <div className="my-5 flex md:flex-row flex-col justify-center items-center md:gap-20 md:items-start">
            {plans
              .filter((plan) => {
                // hide Free plan if user is subscribed
                if (isSubscribed && plan.quantity === "Single Card Option") {
                  return false;
                }
                return true;
              })
              .map((plan, index) => (
                <PlanCard
                  key={index}
                  planId={plan.planId}
                  quantity={plan.quantity}
                  price={plan.price}
                  features={plan.features}
                  is_subscribed={plan.is_subscribed}
                  stripeCustomerId={stripeCustomerId}
                  basicSubscriptionPlanId={plan.basicSubscriptionPlanId}
                  stripPlansinfo={stripPlansinfo}
                  subscription={subscription}
                  me={me}
                  index={index}
                />
              ))}
          </div>
        </LayoutForLandingPage>
      </div>
    </section>
  );
};

export default PremiumPlan;
